import React from 'react';
import { Avatar } from '@material-ui/core';
import AccountIcon from '@material-ui/icons/AccountCircle';
import useMobile from 'utils/useMobile';

import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  mobileSize: {
    width: 32,
    height: 32
  }
}));
const UserAvatar = ({ authUser }) => {
  const classes = useStyles({})
;

  const isMobile = useMobile();
  const rootClass = isMobile ? classes.mobileSize : '';
  return (
    <Avatar className={rootClass} src={authUser.photoURL}>
      {!authUser.photoURL && <AccountIcon />}
    </Avatar>
  );
};

export default UserAvatar;
